import GeneralTracker from '../GeneralTracker';


export default class ModalsTracker extends GeneralTracker {
  STORAGE_KEY = 'modalsInteractionKey';
  CAPTURE_NAME = 'ui:modals:interaction';
  VERSION = '1';

  setHandlers() {
    const service = this.getService();

    service.on('openModal', this.onOpen);
    service.on('closeModal', this.onClose);
  }

  onOpen = (payload) => {
    this.track({
      action: 'open',
      details: payload,
    });
  };

  onClose = (payload) => {
    this.track({
      action: 'close',
      details: payload,
    });
  };

  parsePayload = (payload) => {
    const { action, details: payloadDetails, ...payloadOther } = payload;

    const trackPayload = {
      action: `${action}Modal`,
      labels: {
        ...payloadDetails,
        other: payloadOther,
      },
    };

    return trackPayload;
  };

  track = (payload) => {
    const trackPayload = this.parsePayload(payload);

    super.track(trackPayload);
  };
}
